import React from "react";

import { Form, Input, Button } from "antd";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class LocalLoginForm extends React.Component {
  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.submitHandler(values);
      }
    });
  };

  render() {
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched
    } = this.props.form;

    // Only show error after a field is touched.
    const userNameError =
      isFieldTouched("userName") && getFieldError("userName");
    const passwordError =
      isFieldTouched("password") && getFieldError("password");

    /*const formItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 17 }
    };*/

    return (
      <Form layout="horizontal"
        onSubmit={this.handleSubmit}
        hideRequiredMark={true}
        style={{ marginLeft: "1.5em" }}>
        <Form.Item
          label={<span
            style={{ paddingRight: "0.5em", width: "5.2em", textAlign: "right", display: "inline-block" }}>
            <span style={{ color: "red" }}>*</span>Логин:</span>}
          //{...formItemLayout}
          validateStatus={userNameError ? "error" : ""}
          colon={false}
          help={userNameError || ""}
        >
          {getFieldDecorator("userName", {
            rules: [{ required: true, message: "Необходимо ввести логин" }]
          })(<Input />)}
        </Form.Item>
        <Form.Item
          label={<span
            style={{ paddingRight: "0.5em", width: "5.2em", textAlign: "right", display: "inline-block" }}>
            <span style={{ color: "red" }}>*</span>Пароль:</span>}
          //{...formItemLayout}
          validateStatus={passwordError ? "error" : ""}
          colon={false}
          help={passwordError || ""}
        >
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Необходимо ввести пароль" }]
          })(<Input type="password" />)}
        </Form.Item>
        <Form.Item style={{ marginLeft: "5.4em" }}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={hasErrors(getFieldsError())}
          >
            Войти
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const LoginForm = Form.create({ name: "horizontal_login" })(LocalLoginForm);

export default LoginForm;
